<template>
  <span class="inventory-status">
    <bx-tag v-if="status === 0" color="yellow">{{
      $t("lang.inventory.box_status.label_pending")
    }}</bx-tag>
    <bx-tag v-else-if="status === 1" color="blue">{{
      $t("lang.inventory.box_status.label_computing")
    }}</bx-tag>
    <bx-tag v-else-if="status === 3" color="red">{{
      $t("lang.inventory.box_status.label_canceled")
    }}</bx-tag>
    <bx-tag v-else-if="status === 2" color="green">{{
      $t("lang.inventory.box_status.label_validated")
    }}</bx-tag>
  </span>
</template>
<script>
export default {
  name: "bx-inventory-status",
  props: {
    status: {
      type: [Number],
      default: false
    }
  }
};
</script>
